import {makeReactContext} from 'lib/makeReactContext';
import {ProgressData} from 'llm/chat-library/progress/ProgressTypes';
import {LLMMarkdownTableClassNames} from 'llm/markdown/TableWithCitations';

export type LLMMarkdownClassNames = {
  chip?: string;
  tableCopyButton?: string;
} & LLMMarkdownTableClassNames;

export interface LLMMarkdownDependencies {
  onCitationClick?: (toolId: string, isSourceCitation?: boolean) => void;
  progressData?: ProgressData;
  citationNumberMap?: Map<string, number>;
  chatSessionId?: string;
  classNames?: LLMMarkdownClassNames;
  /**
   * Whether to show the per-chart "Add to entry" button. Defaults to false so the button is
   * only rendered in interactive chat contexts that opt in; it stays hidden in readonly/shared
   * chats and in non-chat markdown surfaces (e.g. Omnibox, skill files) where saving a chart to
   * an entry does not apply.
   */
  canSaveChartsToEntry?: boolean;
}

export const LLMMarkdownDependenciesContext = makeReactContext<LLMMarkdownDependencies>(
  () => ({}),
  'LLMMarkdownDependenciesContext'
);

export function useLLMMarkdownDependencies(): LLMMarkdownDependencies {
  return LLMMarkdownDependenciesContext.useContext();
}
